<template>
  <div>
    <div class="page-body">
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-form
            :inline="true"
            class="demo-form-inline"
            label-position="right"
            label-width="100px"
            :model="searcheForm"
          >
            <el-form-item label="用户昵称:">
              <el-input placeholder="请输入昵称" clearable width="200px" v-model="searcheForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="手机号吗:">
              <el-input placeholder="请输入手机号码" clearable width="200px" v-model="searcheForm.phone"></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="initChargeUserList">搜索</el-button>
          </el-form>
        </div>
        <div>
          <!--<el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">新增</el-button> -->
        </div>
      </div>
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table
        :data="chargeUsers"
        stripe
        border
        v-loading="loading"
        element-loading-text="正在加载..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <el-table-column prop="openId" label="用户ID" fixed align="center" width="400"></el-table-column>
        <el-table-column  label="头像" width="100" fixed align="center">
          <template slot-scope="scope" >
          <el-image style="width: 100px; height: 100px"  :src="scope.row.avatarUrl" :fit="fit"><i class="el-icon-picture-outline"></i></el-image>

          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" width="200" fixed align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="200" fixed align="center"></el-table-column>
        <el-table-column prop="email" label="电子邮箱" width="200" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" width="300" align="center"></el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="200" align="center"></el-table-column>
        <el-table-column fixed="right" width="300" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="goChargingOrder(scope.row)" icon>详情</el-button>
            <el-button @click="showEditEmpView(scope.row)">编辑</el-button>
            <el-button @click="deleteUser(scope.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 表格 END -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
      <div>
        <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="OpenId:" prop="openId">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.openId"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="昵称:" prop="nickname">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.nickname"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名:" prop="username">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.username"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="地址:" prop="address">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注信息:" prop="remark">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.remark"
              placeholder="请输入插座数量"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAddEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteRequest,
  putRequest,
  getRequest,
  postRequest,
} from "../../utils/api";
import { apiListChargeUsers, apiUpdate, apiGet, apiDelete } from "./api";

export default {
  name: "ChargeUser",
  data() {
    return {
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      chargeUsers: [], //列表数据
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      fit:'fill ',
      form: {},
      formRules: {
        equipmentCode: [
          { required: true, message: "请输桩id", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        imei: [
          { required: true, message: "请输IMEI码", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        buildArea: [
          { required: true, message: "请输建桩位置", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        macAddress: [
          { required: true, message: "请输入设备MAC码", trigger: "blur" },
        ],
        connectorNumber: [
          { required: true, message: "请输入插座数量", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.initChargeUserList();
  },
  methods: {
    formatGender(row, column) {
      return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
    },
    formatEnable(row, colum) {
      return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
    },
    // 添加用户按钮
    showAddEmpView() {
      this.form = {};
      this.title = "新增";
      this.dialogVisible = true;
    },
    //编辑用户按钮
    showEditEmpView(data) {
      this.title = "编辑";
      this.form = data;
      this.dialogVisible = true;
    },
    goChargingOrder(data) {
      this.$router.push({ path:'/appuser/AppUserDetail', query: { id:data.id,openId:data.openId} });
    },
    // 删除用户
    deleteUser(data) {
      this.$confirm(
        "此操作将永久删除【" + data.nickname + "】, 是否继续?",
        "提示",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          deleteRequest(`/api/charging-user/delete/${data.id}`).then((resp) => {
            if (resp) {
              this.initChargeUserList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加卡 && 更新卡信息
    doAddEdit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          let url = "";
          let res;
          url = `/api/charging-user/update`;
          res = putRequest(url, this.form);
          res.then((resp) => {
            if (resp) {
              this.dialogVisible = false;
              this.initChargeUserList();
            }
          });
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.initChargeUserList();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.initChargeUserList("advanced");
    },
    // 查询桩列表
    async initChargeUserList(type) {
      this.loading = true;
      this.searcheForm.page=this.page;
      this.searcheForm.size=this.size;
      const response = await apiListChargeUsers({
        ...this.searcheForm,
        ...this.page,
        ...this.size
      });
      //   if (response.status==200) {
      let data = response.data;
      this.chargeUsers = data.list;
      this.total = data.total;
      //   }
      this.loading = false;
    },
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>